import { render, staticRenderFns } from "./ViTeacherAcademicManagementOverView.vue?vue&type=template&id=65629aa8"
import script from "./ViTeacherAcademicManagementOverView.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementOverView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports